<template>
  <v-app>
    <Header></Header>
    <main>
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </main>
    <Footer></Footer>
  </v-app>
</template>

<script>
import Header from "./components/Header";
import Footer from "./components/Footer";

export default {
  name: "App",
  components: {
    Header,
    Footer,
  },
};
</script>

<style lang="scss">
main {
  background-color: $dark-bg;
  min-height: 100vh;
}

// Language switch (classes set on <html> by src/i18n). Each section's content wrapper fades while
// the section background stays, so the page backdrop never flashes. Fading a few wrappers by opacity
// stays on the GPU; fading text colour on every element stuttered on heavy pages like Homekind.
.lang-fade {
  main .section-container,
  main .split__content,
  main .split__visual,
  footer .mira-footer__container {
    transition: opacity 0.15s ease;
    will-change: opacity;
  }
}

.lang-fade--out {
  main .section-container,
  main .split__content,
  main .split__visual,
  footer .mira-footer__container {
    opacity: 0;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
